import React, { Fragment } from 'react';
import './ovRejection-notifiction.scss';
import { NOTIFICATION_TYPE, IMAGE_TYPE, CLICK_TYPE } from './notification.constant';

const OvRejectionNotification = ({ show = false, type = NOTIFICATION_TYPE.DEFAULT, message, eventHandler, hideCancelButton = false, onCancel, imgSrc }) => {
  const onMessageClick = (event) => {
    const { innerText, dataset } = event && event.target;
    if (dataset && dataset.type === CLICK_TYPE.LINK) {
      eventHandler && eventHandler({ nodeInfo: dataset, event: event, innerText });
    }
  };

  const renderNotification = (type) => {
    return (
      <div className="toast_container">
        <div className="toast_wrapper">
          <div className={`toast_content ${type}`}>
            {/* "toast_warning", "toast_error", "toast_success" */}
            <span className="toast_type_icon">
              <img src={imgSrc ? imgSrc : type ? IMAGE_TYPE[type] : IMAGE_TYPE[NOTIFICATION_TYPE.DEFAULT]} alt="Checked" />
            </span>
            <div data-testid="notification-body" class="toast_message" onClick={onMessageClick}>
              {message}
            </div>
            {!hideCancelButton && <span role="button" onClick={onCancel} className="cross_icon"></span>}
          </div>
        </div>
      </div>
    );
  };

  return show ? <Fragment>{renderNotification(type)}</Fragment> : null;
};

export { OvRejectionNotification, NOTIFICATION_TYPE, CLICK_TYPE };
